var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1463_16218)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58492 0H13.3583L19.3373 5.98012V17.4637C19.3373 18.8582 18.1966 20 16.801 20H6.58496C5.19051 20 4.0498 18.8582 4.0498 17.4637V2.53629C4.0498 1.14184 5.19051 0 6.58492 0Z",
    fill: "#E5252A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3584 0L19.3374 5.98012H14.003C13.6476 5.98012 13.3584 5.68981 13.3584 5.33434V0Z",
    fill: "#B71D21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21875 8.51642H14.9929C15.2992 8.51642 15.5495 8.76673 15.5495 9.07306V14.1262C15.5495 14.4325 15.2992 14.6828 14.9929 14.6828H1.21875C0.912422 14.6828 0.662109 14.4325 0.662109 14.1262V9.07306C0.662109 8.76673 0.912461 8.51642 1.21875 8.51642Z",
    fill: "#B71D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59967 9.54681H3.56068C3.38236 9.54681 3.23779 9.69138 3.23779 9.8697V11.5728V11.9922V13.3284C3.23779 13.5067 3.38236 13.6513 3.56068 13.6513C3.739 13.6513 3.88357 13.5067 3.88357 13.3284V12.3151H4.59963C5.35057 12.3151 5.9615 11.7042 5.9615 10.9533V10.9087C5.96154 10.1578 5.35061 9.54681 4.59967 9.54681ZM5.31576 10.9532C5.31576 11.3481 4.99451 11.6693 4.59967 11.6693H3.88357V11.5727V10.1926H4.59963C4.99447 10.1926 5.31572 10.5138 5.31572 10.9086V10.9532H5.31576ZM8.07436 9.54681H7.03541C6.85709 9.54681 6.71252 9.69138 6.71252 9.8697V13.3284C6.71252 13.5067 6.85709 13.6513 7.03541 13.6513H8.07436C8.82529 13.6513 9.43623 13.0403 9.43623 12.2894V10.9087C9.43623 10.1578 8.82529 9.54681 8.07436 9.54681ZM8.79045 12.2894C8.79045 12.6842 8.4692 13.0054 8.07436 13.0054H7.3583V10.1926H8.07436C8.4692 10.1926 8.79045 10.5138 8.79045 10.9086V12.2894ZM10.8958 10.1926V11.0864H12.3926C12.5709 11.0864 12.7155 11.231 12.7155 11.4093C12.7155 11.5876 12.5709 11.7322 12.3926 11.7322H10.8958V13.3284C10.8958 13.5067 10.7512 13.6513 10.5729 13.6513C10.3946 13.6513 10.25 13.5067 10.25 13.3284V9.8697C10.25 9.69138 10.3946 9.54681 10.5729 9.54681H12.6508C12.8292 9.54681 12.9737 9.69138 12.9737 9.8697C12.9737 10.048 12.8292 10.1926 12.6508 10.1926H10.8958Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1463_16218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b3306c9c1f39071b011948e465386a40.svg";
export { ForwardRef as ReactComponent };